import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PcpComponent } from './pcp.component';
import { PcpOverlayComponent } from './pcp-overlay.component';
import { PcpDeselectOverlayComponent } from './pcp-deselect-overlay.component';
import { TranslateModule } from '@ngx-translate/core';
import { PcpMessageComponent } from './pcp-message.component';
import {
  PageContainerModule,
  FlashMessageModule,
  PipesModule,
  EventStopPropagationModule,
} from '@zelis/platform-ui-components';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { DisclaimersModule } from '@components/disclaimers';
import { DlsProgressSpinnerModule } from '@zelis/dls/progress-spinner';
import { DlsButtonModule } from '@zelis/dls/button';
import { DlsDialogModule } from '@zelis/dls/dialog';
import { DlsIconModule } from '@zelis/dls/icons';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    PageContainerModule,
    FlashMessageModule,
    FlexLayoutModule,
    EventStopPropagationModule,
    PipesModule,
    DisclaimersModule,
    DlsProgressSpinnerModule,
    DlsButtonModule,
    DlsDialogModule,
    DlsIconModule,
    MatTooltipModule,
  ],
  declarations: [
    PcpComponent,
    PcpOverlayComponent,
    PcpDeselectOverlayComponent,
    PcpMessageComponent,
  ],
  exports: [
    PcpComponent,
    PcpOverlayComponent,
    PcpDeselectOverlayComponent,
    PcpMessageComponent,
  ],
  providers: [],
})
export class PcpModule {}
